// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2-Kxz","label":"Labeled_label__1XHvB","divider":"Labeled_divider__NvtAG"};